module.exports = __webpack_public_path__ + "static/media/71145.bc3c8e48.jpg";